module.exports = __webpack_public_path__ + "static/media/af18.f581d2ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/af18.jpg
// module id = 170
// module chunks = 0